import { SVGProps } from 'react';
import { SvgSymbolIds } from '../constants';
export function IconArrowSquareLeft(props: SVGProps<SVGSVGElement>) {
  return <svg {...props} data-sentry-element="svg" data-sentry-component="IconArrowSquareLeft" data-sentry-source-file="arrow-square-left.tsx">
            <use href={`#${SvgSymbolIds.ArrowSquareLeft}`} data-sentry-element="use" data-sentry-source-file="arrow-square-left.tsx" />
        </svg>;
}